export default __webpack_public_path__ + "static/media/classes.807645ff.svg";